import React from 'react';
import moment from 'moment/moment';
import { Box, Grid, Stack } from '@mui/material';
import { ConsistType, EventCardView } from '@enums';
import { PageTitle } from '@components/page-title';
import { InfoText, Match, NumberText, TeamLogo, TeamName, TeamTitle } from './sector-title.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SectorTitle = function SectorTitle(_ref) {
  var _event$teamALogoLink, _event$teamACaption, _event$teamBLogoLink, _event$teamBCaption, _event$eventCaption, _event$eventCaption2, _event$eventSessionTy;

  var cardView = _ref.cardView,
      event = _ref.event,
      backRoute = _ref.backRoute;
  return /*#__PURE__*/_jsxs(Box, {
    children: [/*#__PURE__*/_jsx(PageTitle, {
      backRoute: backRoute
    }), /*#__PURE__*/_jsxs(Match, {
      $empty: cardView === EventCardView.EMPTY || cardView === EventCardView.SINGLE,
      children: [cardView === EventCardView.FULL && /*#__PURE__*/_jsxs(Grid, {
        container: true,
        zIndex: 1,
        children: [/*#__PURE__*/_jsxs(Grid, {
          item: true,
          xs: 6,
          children: [/*#__PURE__*/_jsx(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: {
              desktop: 130,
              mobile: 100
            },
            children: /*#__PURE__*/_jsx(TeamLogo, {
              src: (_event$teamALogoLink = event === null || event === void 0 ? void 0 : event.teamALogoLink) !== null && _event$teamALogoLink !== void 0 ? _event$teamALogoLink : '',
              alt: ""
            })
          }), /*#__PURE__*/_jsx(Box, {
            display: "flex",
            justifyContent: "center",
            children: /*#__PURE__*/_jsx(TeamName, {
              component: "span",
              children: (_event$teamACaption = event === null || event === void 0 ? void 0 : event.teamACaption) !== null && _event$teamACaption !== void 0 ? _event$teamACaption : ''
            })
          })]
        }), /*#__PURE__*/_jsxs(Grid, {
          item: true,
          xs: 6,
          children: [/*#__PURE__*/_jsx(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: {
              desktop: 130,
              mobile: 100
            },
            children: /*#__PURE__*/_jsx(TeamLogo, {
              src: (_event$teamBLogoLink = event === null || event === void 0 ? void 0 : event.teamBLogoLink) !== null && _event$teamBLogoLink !== void 0 ? _event$teamBLogoLink : '',
              alt: ""
            })
          }), /*#__PURE__*/_jsx(Box, {
            display: "flex",
            justifyContent: "center",
            children: /*#__PURE__*/_jsx(TeamName, {
              component: "span",
              children: (_event$teamBCaption = event === null || event === void 0 ? void 0 : event.teamBCaption) !== null && _event$teamBCaption !== void 0 ? _event$teamBCaption : ''
            })
          })]
        })]
      }), cardView === EventCardView.SINGLE && /*#__PURE__*/_jsx(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        children: /*#__PURE__*/_jsx(TeamTitle, {
          children: (_event$eventCaption = event === null || event === void 0 ? void 0 : event.eventCaption) !== null && _event$eventCaption !== void 0 ? _event$eventCaption : ''
        })
      }), cardView === EventCardView.EMPTY && /*#__PURE__*/_jsx(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        children: /*#__PURE__*/_jsx(TeamTitle, {
          children: (_event$eventCaption2 = event === null || event === void 0 ? void 0 : event.eventCaption) !== null && _event$eventCaption2 !== void 0 ? _event$eventCaption2 : ''
        })
      })]
    }), /*#__PURE__*/_jsxs(Stack, {
      py: {
        desktop: 4,
        tablet: 2,
        mobile: 2
      },
      direction: "column",
      children: [(event === null || event === void 0 ? void 0 : event.consistType) !== ConsistType.SEASON_TICKET && (event === null || event === void 0 ? void 0 : event.consistType) !== ConsistType.FLEX_PASS && /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        gap: 1.5,
        children: [/*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(NumberText, {
            component: "span",
            textTransform: "uppercase",
            children: moment(event === null || event === void 0 ? void 0 : event.dateBegin, undefined, 'ru').format('D MMMM')
          })
        }), /*#__PURE__*/_jsxs(Box, {
          display: "flex",
          children: [/*#__PURE__*/_jsx(NumberText, {
            component: "span",
            textTransform: "uppercase",
            children: moment(event === null || event === void 0 ? void 0 : event.dateBegin).format('YYYY')
          }), "\xA0", /*#__PURE__*/_jsx(InfoText, {
            component: "span",
            textTransform: "capitalize",
            children: moment(event === null || event === void 0 ? void 0 : event.dateBegin, undefined, 'ru').format('dd')
          })]
        }), /*#__PURE__*/_jsx(Box, {
          display: "flex",
          pl: 1.5,
          children: /*#__PURE__*/_jsx(NumberText, {
            component: "span",
            textTransform: "uppercase",
            children: moment(event === null || event === void 0 ? void 0 : event.dateBegin).format('HH:mm')
          })
        })]
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(InfoText, {
          component: "span",
          textTransform: "capitalize",
          children: "".concat((_event$eventSessionTy = event === null || event === void 0 ? void 0 : event.eventSessionTypeName) !== null && _event$eventSessionTy !== void 0 ? _event$eventSessionTy : '').concat(event !== null && event !== void 0 && event.eventSessionMatchdayName ? " ".concat(event === null || event === void 0 ? void 0 : event.eventSessionMatchdayName) : '').concat(event !== null && event !== void 0 && event.seasonName ? ". ".concat(event === null || event === void 0 ? void 0 : event.seasonName) : '')
        })
      })]
    })]
  });
};

export { SectorTitle };